module.exports = __webpack_public_path__ + "static/media/it.34645007.pdf";